import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=4875f83f"
import script from "./customTable.ts?vue&type=script&lang=js&external"
export * from "./customTable.ts?vue&type=script&lang=js&external"
import style0 from "./customTable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports